import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { APP_CONSTANT, AppConst } from 'src/app/core/_constants/app.constant';
import { showDuration } from 'src/app/core/_constants/helper';
import { ValidationService } from 'src/app/core/_services/common/validation.service';


@Component({
  selector: 'app-cheque-payment',
  templateUrl: './cheque-payment.component.html',
  styleUrls: ['./cheque-payment.component.scss']
})
export class ChequePaymentComponent implements OnInit {
  validationErrorMessage = APP_CONSTANT.VALIDATION;
  maxLength = AppConst.MAXLENGTH;
  public chargeForm: FormGroup;
  submitted: boolean = false;

  constructor(public dialogRef: MatDialogRef<ChequePaymentComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, public validationService: ValidationService) {
  }


  ngOnInit(): void {
    this.chargeForm = this.createForm();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.chargeForm.patchValue({
        date: moment().format('yyyy-MM-DD')
      });
    })
  }

  createForm() {
    return this.fb.group({
      payeeName: ['', Validators.required],
      date: ['', Validators.required],
      chequeNumber: ['', Validators.required],
      bankName: ['', Validators.required]
    })
  }

  get f() { return this.chargeForm.controls; }

  close(value: Boolean) {
    if (this.chargeForm.valid) {
      this.dialogRef.close(value);
    }
  }

  chargeSubmit() {
    this.submitted = true;
    if (this.chargeForm.valid) {
      let data: any = {
        paymentMethod: 2,
        payeeDetails: {
          payeeName: this.chargeForm.value.payeeName,
          bankName: this.chargeForm.value.bankName,
          chequeNumber: this.chargeForm.value.chequeNumber,
          date: this.chargeForm.value.date
        }
      }
      if (this.data.subNewData) {
        data['paymentMode'] = 2;
        data['paymentMethod'] = 2;
        data['isManage'] = true;
        data['companyId'] = this.data.subNewData.companyId;
        data['duration'] = this.data.subNewData.duration;
        data['permissionId'] = this.data.subNewData.permissionId;
        data['packageName'] = this.data.subNewData.packageName;
        data['packageId'] = this.data.subNewData.packageId;
        data['amount'] = this.data.subNewData.amount;
        data['addOns'] = this.data.subNewData.addOns;
        data['numberOfTrucks'] = this.data.subNewData.numberOfTrucks
      }
      this.close(data)
    }
  }

  getDuration(data) {
    return showDuration(data)
  }


}
